import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class LanguageHeaderInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const lang = localStorage.getItem("lang") || "en";

    const modifiedReq = req.clone({
      setHeaders: {
        "Accept-Language": lang,
      },
    });

    return next.handle(modifiedReq);
  }
}
